export const IPIFY_API_URL = "https://api.ipify.org?format=json";